var AlignmentTypes;
(function (AlignmentTypes) {
    AlignmentTypes["LEFT"] = "left";
    AlignmentTypes["CENTER"] = "center";
})(AlignmentTypes || (AlignmentTypes = {}));
var StyleTypes;
(function (StyleTypes) {
    StyleTypes["GREY"] = "grey";
    StyleTypes["OFFWHITE"] = "off-white";
    StyleTypes["BUERGENDY"] = "burgendy";
    StyleTypes["PURPLE"] = "purple";
})(StyleTypes || (StyleTypes = {}));

export { AlignmentTypes, StyleTypes };
